import CardInfoCaptacao from '../components/CardInfoCaptacao'
import EmptyItem from '../components/EmptyItem'
import GraficoFundacoesSaiRanking from '../components/GraficoFundacoesSaiRanking'
import GraficoFundacoesSapRanking from '../components/GraficoFundacoesSapRanking'
import GraficoMedidorAgendamento from '../components/GraficoMedidorAgendamento'
import TablePoliticaAgendamento from '../components/TablePoliticaAgendamento'
import { SEMESTRAL_CHART_DEFAULT_OPTIONS } from '../constants/clients'
import relatorioCaptacaoService from '../services/relatorioCaptacao.service'

const { getTopBottomSai, getTopBottomSap, getRelatorioPoliticaAgendamento } =
	relatorioCaptacaoService()
const { getChoicesActive, FMoneyK, formatReal2 } = GLOBAL
const totaisPorBarraFundacaoTotal = []
const DEFAULT_MAX_MIN = 5
const politicaOpcoes = {
	0: 'ULTRA HIGH',
	1: 'PRIVATE',
	2: 'PREMIUM',
	3: 'DISTRIBUIÇÃO',
}
const politicaOpcoesCores = {
	0: '#840505',
	1: '#d83232',
	2: '#e84f68b3',
	3: '#6d6f71',
}
const dataGastosVazio = [
	{
		name: 'ULTRA HIGH',
		color: '#840505',
		data: [],
	},
	{
		name: 'PRIVATE',
		color: '#d83232',
		data: [],
	},
	{
		name: 'PREMIUM',
		color: '#e84f68b3',
		data: [],
	},
	{
		name: 'DISTRIBUIÇÃO',
		color: '#6d6f71',
		data: [],
	},
]
const colorTypeOptiosnCaptcaoBar = ['#003769', '#C11F39', '#6d6f71']
const colorTypeOptionsCaptacaoTotal = ['#003769', '#C11F39', , '#6d6f71']

// const selectSemestres = GLOBAL.getChoicesActive('semestre', window.listOfChoices)
const URLS = {
	fundo_captacao_pf: '/api/clientepf/dados_totais/',
	fundo_captacao: '/clientes/captacao/',
	total_captacao: '/clientes/captacao_total/',
	total_captacao_sai: '/clientes/captacao_sai/',
	patrimonio_rentabilidade: '/clientes/gastos/',
}

/* const optionsGestao = [
	{
		label: 'Sap',
		value: 'sap',
	},
	{
		label: 'Sai',
		value: 'sai',
	},
	{
		label: 'Ambos',
		value: 'ambos',
	},
] */

export default {
	emits: [],

	components: {
		CardInfoCaptacao,
		EmptyItem,
		GraficoFundacoesSaiRanking,
		GraficoFundacoesSapRanking,
		TablePoliticaAgendamento,
		GraficoMedidorAgendamento,
	},

	data() {
		return {
			optionsGestao: [
				{
					label: 'Sap',
					value: 'sap',
				},
				{
					label: 'Sai',
					value: 'sai',
				},
				/* 				{
					label: 'Ambos',
					value: 'ambos',
				}, */
			],
			filterFaixaMesesPatrimonio: 0,
			filterCaptacao: null,
			filterUsuario: null,
			filterMax: null,
			filterMin: null,
			filterPolitica: null,
			filterSemestreCaptacaoTotal: null,
			filterFaixaPatrimonio: null,
			filterRelatorioPoliticaAgendamento: {
				data_inicio: '',
				data_final: '',
				tipo_gestao: null,
				search: '',
			},
			chartCaptacao: null,
			chartGastos: null,
			chartCaptacaoBarra: null,
			chartCaptacaoTotal: null,
			dataCaptacao: null,
			dataCaptacaoBarra: null,
			dataCaptacaoTotal: {},
			dataCaptacaoTopBottomSap: [],
			dataCaptacaoTopBottomSai: [],
			dataRelatorioPoliticaAgendamento: [],
			labelCaptacaoBarra: [],
			dadosGeraisCaptacaoTotal: {
				patrimonio: 0,
				clientes: 0,
				captacao_ultimo_ano_geral: 0,
				captacao_ultimo_semestre_geral: 0,
			},
			mediaRentabilidade: null,
			todosUsuarios: [],
			captacaoPatrimonioOptions: [
				{ label: '12 meses', value: 12 },
				{ label: '24 meses', value: 24 },
				{ label: '36 meses', value: 36 },
			],
			dataGastos: [
				{
					name: 'ULTRA HIGH',
					color: '#840505',
					data: [],
				},
				{
					name: 'PRIVATE',
					color: '#d83232',
					data: [],
				},
				{
					name: 'PREMIUM',
					color: '#e84f68b3',
					data: [],
				},
				{
					name: 'DISTRIBUIÇÃO',
					color: '#6d6f71',
					data: [],
				},
			],
			optionsGastos: {
				chart: {
					height: 400,
					width: '100%',
					type: 'scatter',
				},
				series: [],
				yaxis: {
					type: 'numeric',
					labels: {
						formatter: function (value) {
							return `${value.toFixed(2).replace('.', ',')}%`
						},
					},
					title: {
						text: 'Rentabilidade (%)',
					},
					// forceNiceScale: true,
					min: -50, // Ajusta o início do eixo X
					max: 50, // Ajusta o final do eixo X
				},
				xaxis: {
					labels: {
						formatter: function (value) {
							const money = new Intl.NumberFormat('pt-BR', {
								style: 'currency',
								currency: 'BRL',
							}).format(value)
							return money
						},
					},
					title: {
						text: 'Patrimônio (R$)',
					},
					min: 0, // Ajusta o início do eixo Y
					max: 13000000, // Ajusta o final do eixo Y
					tickAmount: 10,
				},
				annotations: {
					xaxis: [
						{
							x: 0, // Linha central no eixo Y
							borderColor: '#000',
							strokeDashArray: 5,
							label: {
								text: '',
								position: 'right',
								orientation: 'horizontal',
							},
						},
					],
					yaxis: [
						{
							y: 0, // Linha central no eixo X
							borderColor: '#000',
							strokeDashArray: 5,
							label: {
								text: '',
								position: 'right',
							},
						},
						{
							y: 5, // Linha central no eixo X
							borderColor: '#fdd426',
							strokeDashArray: 5,
							label: {
								text: '',
								textAnchor: 'start',
								position: 'left',
							},
						},
					],
				},
				tooltip: {
					custom: function ({ seriesIndex, dataPointIndex, w }) {
						const point = w.config.series[seriesIndex]?.data[dataPointIndex]

						// Validação de segurança
						if (!point) {
							return '<div class="apexcharts-custom-tooltip">Dados não disponíveis</div>'
						}

						// Função auxiliar para formatação de valores
						const formatValue = (value, suffix = '%') => {
							if (value === null || value === undefined || isNaN(value)) {
								return 'N/A'
							}
							return `${value.toFixed(2).replace('.', ',')}${suffix}`
						}

						const formatCurrency = (value) => {
							if (value === null || value === undefined || isNaN(value)) {
								return 'N/A'
							}
							return new Intl.NumberFormat('pt-BR', {
								style: 'currency',
								currency: 'BRL',
							}).format(value)
						}

						// Construção dos tipos de investimentos
						const tiposInvestimentosHTML =
							point.tipos_investimentos &&
							Array.isArray(point.tipos_investimentos)
								? point.tipos_investimentos
										.filter((item) => item.percentual && item.percentual > 0)
										.map(
											(item) => `
                        <div>
                            <strong>${item.tipo_investimento}:</strong> 
                            <span>${formatValue(item.percentual)}</span>
                        </div>
                    `
										)
										.join('')
								: ''

						return `
                <div class="apexcharts-custom-tooltip" style="border-color: ${
									point.color || '#ccc'
								};">
                    <div class="tooltip-header">
                        <span class="dot" style="background: ${
													point.color || '#ccc'
												};"></span>
                        <strong>${point.label || 'Cliente'}</strong>
                    </div>
                    
                    <div class="tooltip-content">
                        <div class="tooltip-row">
                            <strong>Patrimônio:</strong> 
                            <span>${formatCurrency(point.x)}</span>
                        </div>
                        
                        <div class="tooltip-row">
                            <strong>Rentabilidade:</strong> 
                            <span>${formatValue(point.y)}</span>
                        </div>
                        
                        <div class="tooltip-divider"></div>
                        
                        <div class="tooltip-row">
                            <strong>Volatilidade 1M:</strong> 
                            <span>${formatValue(
															point.volatilidade_media_1M
														)}</span>
                        </div>
                        
                        <div class="tooltip-row">
                            <strong>Volatilidade 3M:</strong> 
                            <span>${formatValue(
															point.volatilidade_media_3M
														)}</span>
                        </div>
                        
                        <div class="tooltip-divider"></div>
                        
                        <div class="tooltip-row">
                            <strong>% CDI 12 meses:</strong> 
                            <span>${formatValue(
															point.rentabilidade_bm_12_meses
														)}</span>
                        </div>
                        
                        <div class="tooltip-row">
                            <strong>% CDI ano:</strong> 
                            <span>${formatValue(
															point.rentabilidade_bm_ano
														)}</span>
                        </div>
                        
                        ${
													tiposInvestimentosHTML
														? `
                            <div class="tooltip-section">
                                ${tiposInvestimentosHTML}
                            </div>
                        `
														: ''
												}
                    </div>
                </div>
            `
					},
				},
			},
			optionsCaptacao: {
				series: [],
				chart: {
					height: 350,
					type: 'line',
					zoom: {
						enabled: false,
					},
					toolbar: {
						show: false,
					},
				},
				colors: ['#949799', '#C11F39'],
				dataLabels: {
					enabled: false,
				},
				stroke: {
					curve: 'straight',
					width: 2,
				},
				markers: {
					size: 4,
				},
				title: {
					text: undefined,
					align: 'left',
				},
				grid: {
					show: true,
					borderColor: '#EDEEF0',
					xaxis: {
						lines: {
							show: true,
						},
					},
					yaxis: {
						lines: {
							show: true,
						},
					},
				},
				xaxis: {
					labels: {
						show: true,
						maxHeight: 50,
						styles: {
							cssClass: 'apexcharts-xaxis-label',
						},
						formatter: function (value) {
							// Exibe a label personalizada ou o valor padrão
							return value ? captacaoXLabel[value] : value
						},
					},
				},
				yaxis: {
					labels: {
						show: true,
						styles: {
							cssClass: 'apexcharts-yaxis-label',
						},
						formatter: function (value) {
							const money = new Intl.NumberFormat('pt-BR', {
								style: 'currency',
								currency: 'BRL',
							}).format(value)
							return money
						},
					},
				},
				legend: {
					fontFamily: 'Roboto Flex',
					fontWeight: 500,
					labels: {
						colors: ['#252526'],
						useSeriesColors: false,
					},
					markers: {
						width: 20,
						height: 4,

						strokeColor: '#fff',

						radius: 8,
					},
					itemMargin: {
						horizontal: 8,
						vertical: 24,
					},
				},
				tooltip: {
					custom: function ({ seriesIndex, dataPointIndex, w }) {
						const point = w.config.series[seriesIndex].data[dataPointIndex]

						const formatReal2 = (v, style = 'currency') =>
							new Intl.NumberFormat('pt-BR', {
								style: style,
								currency: 'BRL',
							}).format(v)

						const meta_acumulado = formatReal2(point.meta_acumulado)
						const acumulado = formatReal2(point.acumulado)

						const dinheiro_novo = formatReal2(point.dinheiro_novo)
						const dinheiro_resgatado = formatReal2(point.dinheiro_resgatado)
						const saldo_liquido = formatReal2(point.saldo_liquido)

						return `
							<div class="apexcharts-custom-tooltip">
								<div>
									<span class="dot" style="background: #949799;"></span>
									<strong>Previsto Acumulado: </strong>
									<span> ${meta_acumulado}</span>
								</div>
								<div>
									<span class="dot" style="background: #C11F39;"></span>
									<strong>Real Acumulado: </strong>
									<span> ${acumulado}</span>
								</div>
								<div><strong>Dinheiro Novo: </strong> <span> ${dinheiro_novo}</span></div>
								<div><strong>Resgate: </strong> <span> ${dinheiro_resgatado}</span></div>
								<div><strong>Saldo Liquido: </strong> <span> ${saldo_liquido}</span></div>
							</div>
						`
					},
				},
			},
			optionsCaptacaoBarra: {
				...SEMESTRAL_CHART_DEFAULT_OPTIONS,
				series: [],
				chart: {
					type: 'bar',
					height: 490,
					stacked: true,
				},
				title: {
					text: 'PLE Unificado',
				},
				legend: {
					fontFamily: 'Roboto Flex',
					fontWeight: 500,
					labels: {
						colors: ['#252526'],
						useSeriesColors: false,
					},
					markers: {
						width: 20,
						height: 4,

						strokeColor: '#fff',

						radius: 8,
					},
					itemMargin: {
						horizontal: 8,
						vertical: 24,
					},
				},
				plotOptions: {
					bar: {
						horizontal: false,
						borderRadius: 6,
						borderRadiusApplication: 'end',
						borderRadiusWhenStacked: 'last',
						barHeight: '100%',
						dataLabels: {
							position: 'top',
							total: {
								enabled: true,
								style: {
									fontSize: '12px',
									fontWeight: 600,
									color: '#373D3F',
								},
								formatter: function (val, opts) {
									return GLOBAL.FMoneyK(val)
								},
								offsetY: -20,
							},
						},
					},
				},
				dataLabels: {
					enabled: false,
				},
				/* 				plotOptions: {
					bar: { dataLabels: { total: { enabled: true } } },
				}, */
				stroke: {
					width: 1,
					colors: ['#fff'],
				},
				fill: {
					opacity: 1,
				},
				colors: colorTypeOptiosnCaptcaoBar,
				yaxis: {
					labels: {
						formatter: (val) => {
							return GLOBAL.FMoneyK(val)
						},
					},
				},

				tooltip: {
					shared: false,
					intersect: true,
					custom: function ({ seriesIndex, dataPointIndex, w }) {
						const series = w.config.series
						const categories = w.config.xaxis.categories
						const ano = categories[dataPointIndex]

						// Pegar apenas o valor da série específica onde o mouse está
						const valorSerie = series[seriesIndex].data[dataPointIndex]
						const nomeSerie = series[seriesIndex].name

						return `
            <div class="apexcharts-custom-tooltip">
                <div>
                    <strong>${nomeSerie}: </strong>
                    <span>${GLOBAL.formatReal2(valorSerie)}</span>
                </div>
            </div>
        `
					},
				},
			},
			optionsFundacaoTotal: {
				series: [],
				chart: {
					height: 350,
					type: 'bar',
					stacked: true,
					zoom: {
						enabled: false,
					},
					toolbar: {
						show: false,
					},
				},
				tooltip: {
					enabled: true,
					shared: false,
					intersect: true,
					custom: function ({ series, seriesIndex, dataPointIndex, w }) {
						if (w.config.series[seriesIndex]?.name === 'Total Fantasma') {
							return ''
						}

						const valor = series[seriesIndex][dataPointIndex]
						const nome = w.config.series[seriesIndex].name
						return `
      <div class="apexcharts-custom-tooltip">
        <strong>${nome}:</strong> <span>${GLOBAL.FMoneyK(valor)}</span>
      </div>
    `
					},
				},
				plotOptions: {
					bar: {
						horizontal: false,
						borderRadius: 6,
						columnWidth: '90%',
						borderRadiusApplication: 'end',
						borderRadiusWhenStacked: 'all',
						dataLabels: {
							hideOverflowingLabels: true,
							total: {
								enabled: true,
								showAlways: true,
								style: {
									fontSize: '12px',
									fontWeight: 600,
									color: '#373D3F',
								},
								formatter: function (val, opts) {
									const idx = opts.dataPointIndex
									// Usa o valor real guardado
									return GLOBAL.FMoneyK(totaisPorBarraFundacaoTotal[idx] || 0)
								},
								offsetY: -20,
								position: 'top',
							},
						},
					},
				},
				colors: colorTypeOptionsCaptacaoTotal,
				dataLabels: {
					enabled: false,
				},
				stroke: {
					curve: 'straight',
					width: 2,
				},
				markers: {
					size: 4,
				},
				title: {
					text: 'Relatório unificado',
					align: 'left',
				},
				grid: {
					row: {
						colors: ['#f3f3f3', 'transparent'],
						opacity: 0.5,
					},
				},
				xaxis: {
					labels: {
						show: true,
						maxHeight: 50,
						styles: {
							cssClass: 'apexcharts-xaxis-label',
						},
						formatter: function (value) {
							return 'Sem ' + value
						},
					},
				},
				yaxis: {
					labels: {
						show: true,
						styles: {
							cssClass: 'apexcharts-yaxis-label',
						},
						formatter: function (value) {
							const money = new Intl.NumberFormat('pt-BR', {
								style: 'currency',
								currency: 'BRL',
							}).format(value)
							return money
						},
					},
				},
				legend: {
					fontFamily: 'Roboto Flex',
					fontWeight: 500,
					labels: {
						colors: ['#252526'],
						useSeriesColors: false,
					},
					markers: {
						width: 20,
						height: 4,

						strokeColor: '#fff',

						radius: 8,
					},
					itemMargin: {
						horizontal: 8,
						vertical: 24,
					},
					formatter: function (seriesName, opts) {
						if (seriesName === 'Total Fantasma') return ''
						return seriesName
					},
				},
			},
		}
	},
	computed: {
		dataRelatorioPoliticaAgendamentoInicial() {
			return this.convertStringDateToISO(
				this.filterRelatorioPoliticaAgendamento.data_inicio
			)
		},
		dataRelatorioPoliticaAgendamentoFinal() {
			return this.convertStringDateToISO(
				this.filterRelatorioPoliticaAgendamento.data_final
			)
		},
		faixaMeses() {
			return [12, 24, 36]
		},
		porcentagemAgendamentoRelatorioFormat() {
			return this.dataRelatorioPoliticaAgendamento?.percentual_geral / 100
		},
		queryTabelaPoliticaAgendamento() {
			const { data_inicio, data_final, tipo_gestao } =
				this.filterRelatorioPoliticaAgendamento
			const params = []

			if (data_inicio)
				params.push(
					`data_inicial=${this.dataRelatorioPoliticaAgendamentoInicial}`
				)
			if (data_final)
				params.push(`data_final=${this.dataRelatorioPoliticaAgendamentoFinal}`)
			if (tipo_gestao)
				params.push(`tipo_gestao=${encodeURIComponent(tipo_gestao)}`)
			return params.join('&')
		},
	},

	watch: {
		filterRelatorioPoliticaAgendamento: {
			handler() {
				if (this.filterRelatorioPoliticaAgendamento) {
					this.setRelatorioAgendamento()
				}
			},
			deep: true,
		},
	},
	methods: {
		initFilterRelatorioPoliticaAgendamentoDates() {
			const now = new Date()
			const year = now.getFullYear()
			const data_inicio = `01/01/${year}`
			const data_final = `31/12/${year}`

			this.filterRelatorioPoliticaAgendamento.data_inicio = data_inicio
			this.filterRelatorioPoliticaAgendamento.data_final = data_final
		},
		convertStringDateToISO(stringDate) {
			if (!stringDate) return ''
			const [day, month, year] = stringDate.split('/')
			return `${year}-${month}-${day}`
		},
		formatReal2: (v, style = 'currency') =>
			new Intl.NumberFormat('pt-BR', {
				style: style,
				currency: 'BRL',
			}).format(v),

		maiorValorProximoRedondo(numero) {
			const magnitude =
				Math.pow(10, Math.floor(numero).toString().length - 1) / 10

			return Math.ceil(numero / magnitude) * magnitude
		},
		openFiltros() {
			modal_padrao_vue.openModal('filtro_rentabilidade')
		},

		async cancelFilter() {
			this.filterFaixaMesesPatrimonio = 0
			this.filterPolitica = ''
			this.filterUsuario = ''
			this.filterMin = ''
			this.filterMax = ''
			modal_padrao_vue.closeModal('filtro_rentabilidade')

			const selectPoliticas = getChoicesActive('politica', window.listOfChoices)
			selectPoliticas.setChoiceByValue('')
			const selectUsuarios = getChoicesActive(
				'usuarios_select',
				window.listOfChoices
			)
			selectUsuarios.setChoiceByValue('')
			const selectFaixaMeses = getChoicesActive(
				'faixa_meses_patrimonio',
				window.listOfChoices
			)
			selectFaixaMeses.setChoiceByValue('')
			const max = document.querySelector('#max')
			const min = document.querySelector('#min')
			min.value = ''
			max.value = ''
			await this.iniciarTabelaGastos()
			this.setTabelaGastosValues()
		},

		setSelectFaixaMesesPatrimonio() {
			const selectFaixaMeses = getChoicesActive(
				'faixa_meses_patrimonio',
				window.listOfChoices
			)
			selectFaixaMeses.setChoices([
				{ value: '', label: 'Ano corrente' },
				...this.captacaoPatrimonioOptions,
			])
			selectFaixaMeses.setChoiceByValue('')
			this.filterFaixaMesesPatrimonio = 0
		},

		async setFilterFaixaMesesPatrimonio(mes) {
			this.filterFaixaMesesPatrimonio = mes

			const selectFaixaMeses = getChoicesActive(
				'faixa_meses_patrimonio',
				window.listOfChoices
			)
			if (selectFaixaMeses) {
				// Sincroniza o select com o botão clicado
				const valorSelect = mes === 0 ? '' : mes.toString()
				selectFaixaMeses.setChoiceByValue(valorSelect)
			}

			await this.iniciarTabelaGastos()
			this.setTabelaGastosValues()
		},

		setSelectEvents() {
			document
				.querySelector('#semestre_select')
				?.addEventListener('change', () => {
					const selectSemestres = getChoicesActive(
						'semestre_select',
						window.listOfChoices
					)
					this.filterCaptacao = selectSemestres.getValue().value
					this.setTabelaCaptacaoValues()
				})
			document
				.querySelector('#usuarios_select')
				?.addEventListener('change', async () => {
					const selectUsuarios = getChoicesActive(
						'usuarios_select',
						window.listOfChoices
					)
					this.filterUsuario = selectUsuarios.getValue().value
					// await this.iniciarTabelaGastos()
					// this.updateTabelaGastosValues()
				})

			document
				.querySelector('#politica')
				?.addEventListener('change', async () => {
					const selectPoliticas = getChoicesActive(
						'politica',
						window.listOfChoices
					)
					this.filterPolitica = selectPoliticas.getValue().value
					// await this.iniciarTabelaGastos()
					// this.updateTabelaGastosValues()
				})

			document
				.querySelector('#semestre_captacao_select')
				?.addEventListener('change', async () => {
					const selectCaptacaoTotal = getChoicesActive(
						'semestre_captacao_select',
						window.listOfChoices
					)
					this.filterSemestreCaptacaoTotal =
						selectCaptacaoTotal.getValue().value

					this.setTabelaCaptacaoTotalValues()
				})

			document
				.querySelector('#faixa_meses_patrimonio')
				?.addEventListener('change', async (e) => {
					const selectFaixaMeses = getChoicesActive(
						'faixa_meses_patrimonio',
						window.listOfChoices
					)
					const valorSelect = selectFaixaMeses.getValue().value

					this.filterFaixaMesesPatrimonio =
						valorSelect === '' ? 0 : parseInt(valorSelect)
				})
		},

		async submitFilters() {
			const selectFaixaMeses = getChoicesActive(
				'faixa_meses_patrimonio',
				window.listOfChoices
			)
			const valorSelect = selectFaixaMeses.getValue().value
			this.filterFaixaMesesPatrimonio =
				valorSelect === '' ? 0 : parseInt(valorSelect)

			// Pegar outros valores do modal
			const selectPoliticas = getChoicesActive('politica', window.listOfChoices)
			this.filterPolitica = selectPoliticas.getValue().value

			const selectUsuarios = getChoicesActive(
				'usuarios_select',
				window.listOfChoices
			)
			this.filterUsuario = selectUsuarios.getValue().value

			const min = document.querySelector('#min').value
			const max = document.querySelector('#max').value
			this.filterMin = min
			this.filterMax = max

			// Fechar modal
			modal_padrao_vue.closeModal('filtro_rentabilidade')

			// Atualizar gráfico
			await this.iniciarTabelaGastos()
			this.setTabelaGastosValues()
		},

		async iniciarTabelas() {
			await this.iniciarTabelaCaptacao()
			await this.iniciarTabelaGastos()
			await this.iniciarTabelaCaptacaoTotalBarra()
			await this.iniciaTabelaCaptacaoTotal()
			this.setTabelasValues()
		},

		setSelectSemestres() {
			const selectSemestres = getChoicesActive(
				'semestre_select',
				window.listOfChoices
			)
			if (this.dataCaptacao) {
				const semestresKey = Object.keys(this.dataCaptacao)
				const options = semestresKey.map((f) => {
					return {
						value: f,
						label: f,
					}
				})
				selectSemestres.setChoices([...options])
				selectSemestres.setChoiceByValue(semestresKey[0])
				this.filterCaptacao = semestresKey[0]
			} else {
				selectSemestres.setChoices([
					{ value: '', label: 'Não há dados disponíveis' },
				])
				selectSemestres.setChoiceByValue('')
				this.filterCaptacao = ''
			}
		},
		setSelectUsuarios() {
			if (this.todosUsuarios.length === 0) {
				return
			}
			const selectUsuarios = getChoicesActive(
				'usuarios_select',
				window.listOfChoices
			)
			const options = this.todosUsuarios.map((v) => {
				return {
					value: v.id,
					label: v.name && v.name.trim().length > 0 ? v.name : v.username,
				}
			})
			selectUsuarios.setChoices([
				{ value: '', label: 'Selecione um usuário' },
				...options,
			])
			selectUsuarios.setChoiceByValue('')
			this.filterUsuario = ''
		},

		setSelectPoliticas() {
			const opcoes = Object.entries(politicaOpcoes).map(([value, label]) => ({
				value,
				label,
			}))
			if (opcoes.length === 0) {
				return
			}
			const selectPoliticas = getChoicesActive('politica', window.listOfChoices)

			selectPoliticas.setChoices([
				{ value: '', label: 'Selecione uma politica' },
				...opcoes,
			])
			selectPoliticas.setChoiceByValue('')
			this.filterPolitica = ''
		},
		setSelectSemestreCaptacao() {
			const semestres = Object.keys(this.dataCaptacaoTotal.totalCaptacao).map(
				(itemFundoCaptacao) => ({
					label: itemFundoCaptacao,
					value: itemFundoCaptacao,
				})
			)

			const semestreCaptacao = getChoicesActive(
				'semestre_captacao_select',
				window.listOfChoices
			)

			semestreCaptacao.setChoices([...semestres])
			semestreCaptacao.setChoiceByValue(semestres[0].value)

			this.filterSemestreCaptacaoTotal = semestres[0].value
		},
		async iniciarTabelaCaptacaoTotalBarra() {
			const { data } = await axios.get(
				`${window.origin}${URLS.fundo_captacao_pf}`
			)
			const labelCaptacaoPf = 'Cliente PF'
			const labelCaptacaoPj = 'Fundação'
			const labelCaptacaoSequoia = 'Sequoia'

			const periodoCaptacaoAnual = {}

			const auxPeriodosCaptacao = []

			this.dadosGeraisCaptacaoTotal.patrimonio = formatReal2(
				data.dados_gerais.patrimonio
			)
			this.dadosGeraisCaptacaoTotal.clientes = data.dados_gerais.clientes
			this.dadosGeraisCaptacaoTotal.captacao_ultimo_ano_geral = formatReal2(
				data.dados_gerais.captacao_ultimo_ano_geral
			)
			this.dadosGeraisCaptacaoTotal.captacao_ultimo_semestre_geral =
				formatReal2(data.dados_gerais.captacao_ultimo_semestre_geral)

			data.dados_individuais.PJ.captacao_patrimonio_anual.forEach(
				(itemCaptacaoPatrimonio) => {
					if (!periodoCaptacaoAnual[labelCaptacaoPj]) {
						periodoCaptacaoAnual[labelCaptacaoPj] = []
					}

					periodoCaptacaoAnual[labelCaptacaoPj].push(
						itemCaptacaoPatrimonio.value
					)

					if (!auxPeriodosCaptacao.includes(itemCaptacaoPatrimonio.name)) {
						auxPeriodosCaptacao.push(itemCaptacaoPatrimonio.name)
					}
				}
			)

			data.dados_individuais.PF.captacao_patrimonio_anual.forEach(
				(itemCaptacaoPatrimonio) => {
					if (!periodoCaptacaoAnual[labelCaptacaoPf]) {
						periodoCaptacaoAnual[labelCaptacaoPf] = []
					}

					periodoCaptacaoAnual[labelCaptacaoPf].push(
						itemCaptacaoPatrimonio.total
					)

					/* if (!auxPeriodosCaptacao.includes(itemCaptacaoPatrimonio.ano)) {
						auxPeriodosCaptacao.push(itemCaptacaoPatrimonio.ano)
					} */
				}
			)

			data.dados_individuais.sequoia.captacao_patrimonio_anual.forEach(
				(itemCaptacaoPatrimonio) => {
					if (!periodoCaptacaoAnual[labelCaptacaoSequoia]) {
						periodoCaptacaoAnual[labelCaptacaoSequoia] = []
					}
					periodoCaptacaoAnual[labelCaptacaoSequoia].push(
						itemCaptacaoPatrimonio.total
					)

					/* if (!auxPeriodosCaptacao.includes(itemCaptacaoPatrimonio.ano)) {
						auxPeriodosCaptacao.push(itemCaptacaoPatrimonio.ano)
					} */
				}
			)

			this.dataCaptacaoBarra = Object.entries(periodoCaptacaoAnual).map(
				([periodo, valor]) => {
					return {
						name: periodo,
						data: valor.reverse(),
					}
				}
			)

			this.labelCaptacaoBarra = auxPeriodosCaptacao.reverse()
			/* console.log(this.dataCaptacaoBarra) */
		},

		async iniciaTabelaCaptacaoTotal() {
			const { data: fundoCaptacao } = await axios.get(
				`${window.origin}${URLS.fundo_captacao}`
			)
			const { data: totalCaptacao } = await axios.get(
				`${window.origin}${URLS.total_captacao}`
			)
			const { data: totalCaptacaoSai } = await axios.get(
				`${window.origin}${URLS.total_captacao_sai}`
			)

			this.dataCaptacaoTotal.fundoCaptacao = fundoCaptacao
			this.dataCaptacaoTotal.totalCaptacao = totalCaptacao
			this.dataCaptacaoTotal.totalCaptacaoSai = totalCaptacaoSai

			this.setSelectSemestreCaptacao()
		},

		async iniciarTabelaCaptacao() {
			const { data } = await axios.get(`${window.origin}/clientes/captacao/`)

			this.dataCaptacao = Object.keys(data).length === 0 ? null : data
			// this.dataCaptacao = null
			this.setSelectSemestres()
		},

		async iniciarTabelaGastos() {
			let filter = '?q='
			filter += !this.filterUsuario ? '' : `&user=${this.filterUsuario}`
			filter += !this.filterPolitica ? '' : `&politica=${this.filterPolitica}`
			filter += !this.filterMin ? '' : `&min=${this.filterMin}`
			filter += !this.filterMax ? '' : `&max=${this.filterMax}`
			const mesesMap = { 12: 'mes_12', 24: 'mes_24', 36: 'mes_36' }
			if (
				this.filterFaixaMesesPatrimonio &&
				this.filterFaixaMesesPatrimonio !== 0
			) {
				filter += `&${mesesMap[this.filterFaixaMesesPatrimonio]}=true`
			}

			const { data } = await axios.get(
				`${window.origin}${URLS.patrimonio_rentabilidade}${filter}`
			)

			this.todosUsuarios = data.todos_users || []
			// this.setSelectUsuarios()
			this.dataGastos.forEach((v, index) => {
				this.dataGastos[index].data = []
			})

			if (!data.results || data.results.length === 0) {
				this.optionsGastos.xaxis.min = 0
				this.optionsGastos.xaxis.max = 13000000
				this.optionsGastos.yaxis.min = -50
				this.optionsGastos.yaxis.max = 50

				this.optionsGastos.annotations.xaxis[0].x = 0
				this.optionsGastos.annotations.xaxis[0].label.text = ''
				this.optionsGastos.annotations.yaxis[0].y = 0
				this.optionsGastos.annotations.yaxis[0].label.text = ''
				this.optionsGastos.annotations.yaxis[1].y = 5
				this.optionsGastos.annotations.yaxis[1].label.text = ''

				return
			}
			const maior_valor = data.results
				.map((v) => v.patrimonio_interno)
				.reduce((max, atual) => Math.max(max, atual), -Infinity)

			this.optionsGastos.xaxis.max = this.maiorValorProximoRedondo(maior_valor)
			if (this.optionsGastos.yaxis.length) {
				this.optionsGastos.yaxis[0].min =
					parseFloat(data.menor_rentabilidade_12_meses_y) - DEFAULT_MAX_MIN
				this.optionsGastos.yaxis[0].max =
					parseFloat(data.maior_rentabilidade_12_meses_y) + DEFAULT_MAX_MIN
			} else {
				this.optionsGastos.yaxis.min =
					parseFloat(data.menor_rentabilidade_12_meses_y) - DEFAULT_MAX_MIN
				this.optionsGastos.yaxis.max =
					parseFloat(data.maior_rentabilidade_12_meses_y) + DEFAULT_MAX_MIN
			}

			this.optionsGastos.annotations.yaxis[0].y =
				data.media_rentabilidade_12_meses
			this.optionsGastos.annotations.yaxis[0].label.text = `Mediana: ${data.media_rentabilidade_12_meses
				.toFixed(2)
				.replace('.', ',')}%`

			this.optionsGastos.annotations.xaxis[0].x = data.media_patrimonio_interno
			this.optionsGastos.annotations.xaxis[0].label.text = `Média: ${this.formatReal2(
				data.media_patrimonio_interno
			)}`

			this.optionsGastos.annotations.yaxis[1].y = data.cdi_12_meses

			this.optionsGastos.annotations.yaxis[1].label.text = `CDI: ${data.cdi_12_meses
				.toFixed(2)
				.replace('.', ',')}%`

			data.results.forEach((v, index) => {
				const politicaKey = Number(v.politica)
				const serie = this.dataGastos.find(
					(w) => w.name === politicaOpcoes[politicaKey]
				)
				if (serie) {
					serie.data.push({
						x: Number(v.patrimonio_interno),
						y: Number(v.rentabilidade_12_meses) || Number(v.rentabilidade_ano),
						label: v.nome,
						color: politicaOpcoesCores[politicaKey],
						volatilidade_media_1M: Number(v.medias.volatilidade_media_1M) || 0,
						volatilidade_media_3M: Number(v.medias.volatilidade_media_3M) || 0,
						rentabilidade_bm_12_meses: Number(
							v.bm_cdi[0].rentabilidade_bm_12_meses
						),
						rentabilidade_bm_ano: Number(v.bm_cdi[0].rentabilidade_bm_ano),
						tipos_investimentos: v.investimentos.tipos_investimento,
					})

					/* console.log('Ponto plotado:', {
						x: Number(v.patrimonio_interno),
						y: Number(v.rentabilidade_12_meses) || Number(v.rentabilidade_ano),
						label: v.nome,
					}) */
				}
			})
		},

		setTabelaCaptacaoValues() {
			if (this.chartCaptacao) this.chartCaptacao.destroy()

			const metaAcumulado = !this.dataCaptacao
				? []
				: this.dataCaptacao[this.filterCaptacao].map((v, index) => {
						return {
							x: index + 1,
							y: Number(v.meta_acumulado),
							label: `Sem ${v.semana}`,
							dinheiro_novo: Number(v.dinheiro_novo),
							dinheiro_resgatado: Number(v.dinheiro_resgatado),
							saldo_liquido: Number(v.saldo_liquido),
							meta_acumulado: Number(v.meta_acumulado),
							acumulado: Number(v.acumulado),
						}
				  })

			const acumulado = !this.dataCaptacao
				? []
				: this.dataCaptacao[this.filterCaptacao].map((v, index) => {
						return {
							x: index + 1,
							y: Number(v.acumulado),
							label: `Sem ${v.semana}`,
							dinheiro_novo: Number(v.dinheiro_novo),
							dinheiro_resgatado: Number(v.dinheiro_resgatado),
							saldo_liquido: Number(v.saldo_liquido),
							meta_acumulado: Number(v.meta_acumulado),
							acumulado: Number(v.acumulado),
						}
				  })

			captacaoXLabel = Object.fromEntries(
				metaAcumulado.map((point) => [point.x, point.label])
			)

			const seriesSemestre = [
				{
					name: 'Meta',
					data: metaAcumulado,
				},
				{
					name: 'Realizado',
					data: acumulado,
				},
			]

			this.optionsCaptacao.series = seriesSemestre
			this.chartCaptacao = new ApexCharts(
				document.querySelector('#chart_captacao'),
				this.optionsCaptacao
			)
			this.chartCaptacao.render()
		},
		setTabelaGastosValues() {
			if (this.chartGastos) this.chartGastos.destroy()
			this.optionsGastos.series = this.dataGastos

			const el = document.querySelector('#chart_gastos')
			if (!el) {
				console.error('Elemento #chart_gastos não encontrado!')
				return
			}

			this.chartGastos = new ApexCharts(
				document.querySelector('#chart_gastos'),
				this.optionsGastos
			)

			this.chartGastos.render()
		},
		setTabelaCaptacaoBarValues() {
			if (this.chartCaptacaoBarra) this.chartCaptacaoBarra.destroy()

			// Calcula o valor máximo de todas as séries
			const calcularValorMaximo = () => {
				let maxValue = 0

				this.dataCaptacaoBarra.forEach((serie) => {
					serie.data.forEach((valor, index) => {
						// Soma todos os valores do mesmo índice (barras empilhadas)
						const somaEmpilhada = this.dataCaptacaoBarra.reduce((total, s) => {
							return total + (s.data[index] || 0)
						}, 0)

						if (somaEmpilhada > maxValue) {
							maxValue = somaEmpilhada
						}
					})
				})

				return maxValue
			}

			const valorMaximo = calcularValorMaximo()

			const margemSuperior = valorMaximo

			this.optionsCaptacaoBarra.series = this.dataCaptacaoBarra
			this.optionsCaptacaoBarra.xaxis.categories = this.labelCaptacaoBarra

			this.optionsCaptacaoBarra.yaxis.max = margemSuperior
			this.optionsCaptacaoBarra.yaxis.min = 0

			this.chartCaptacaoBarra = new ApexCharts(
				document.querySelector('#chart_captacao_barra'),
				this.optionsCaptacaoBarra
			)

			this.chartCaptacaoBarra.render()
		},
		setTabelaCaptacaoTotalValues() {
			if (this.chartCaptacaoTotal) this.chartCaptacaoTotal.destroy()

			const captacaoFundoMeta = {
				name: 'Captação SAP',
				data: this.dataCaptacaoTotal.fundoCaptacao[
					this.filterSemestreCaptacaoTotal
				].map((itemFundoCaptacao) => {
					return parseFloat(itemFundoCaptacao.acumulado)
				}),
			}

			const captacaoTotalMeta = {
				name: 'Captação SAI',
				data: this.dataCaptacaoTotal.totalCaptacaoSai[
					this.filterSemestreCaptacaoTotal
				].map((itemTotalCaptacao) => {
					return parseFloat(itemTotalCaptacao.total_captacao)
				}),
			}

			const captacaoTotalSaiMeta = {
				name: 'Captação TOTAL',
				data: this.dataCaptacaoTotal.totalCaptacao[
					this.filterSemestreCaptacaoTotal
				].map((itemTotalCaptacaoSai) => {
					return parseFloat(itemTotalCaptacaoSai.total_captacao)
				}),
			}

			const seriesOriginais = [captacaoTotalMeta, captacaoFundoMeta]
			const tamanho = Math.max(
				captacaoTotalMeta.data.length,
				captacaoFundoMeta.data.length
			)

			const serieFantasma = {
				name: 'Total Fantasma',
				data: [],
				color: 'transparent',
				tooltip: { enabled: false },
				showInLegend: false,
				legendIcon: 'none',
				legend: {
					show: false,
				},
				events: {},
			}

			for (let i = 0; i < tamanho; i++) {
				const valores = seriesOriginais.map((serie) => serie.data[i] || 0)
				const valoresPositivos = valores.filter((v) => v > 0)
				const valoresAbsolutos = valores.map((v) => Math.abs(v))

				const maiorAbsoluto = valoresAbsolutos.length
					? Math.max(...valoresAbsolutos)
					: 0

				const totalReal = valores.reduce((acc, v) => acc + v, 0)

				const valorFantasma = 2
				totaisPorBarraFundacaoTotal[i] = totalReal
				serieFantasma.data.push(valorFantasma)
			}

			if (captacaoTotalMeta.data.length !== captacaoFundoMeta.data.length) {
				const maxLenght = Math.max(
					captacaoTotalMeta.data.length,
					captacaoFundoMeta.data.length
				)

				for (let i = 0; i < maxLenght; i++) {
					if (!captacaoTotalMeta.data[i]) {
						captacaoTotalMeta.data[i] = null
					}

					if (!captacaoFundoMeta.data[i]) {
						captacaoFundoMeta.data[i] = null
					}
				}
			}
			this.optionsFundacaoTotal.series = [
				captacaoTotalMeta,
				captacaoFundoMeta,
				serieFantasma,
				/* 				captacaoTotalSaiMeta, */
			]

			this.optionsFundacaoTotal.xaxis.categories =
				this.dataCaptacaoTotal.fundoCaptacao[
					this.filterSemestreCaptacaoTotal
				].map((itemFundoCaptacao) => itemFundoCaptacao.semana)

			this.chartCaptacaoTotal = new ApexCharts(
				document.querySelector('#chart_fundacao_total'),
				this.optionsFundacaoTotal
			)

			this.chartCaptacaoTotal.render()
		},
		updateTabelaGastosValues() {
			this.chartGastos.updateOptions(this.optionsGastos)
			this.chartGastos.updateSeries(this.dataGastos)
		},
		setTabelasValues() {
			this.setTabelaCaptacaoValues()
			this.setTabelaGastosValues()
			this.setTabelaCaptacaoBarValues()
			this.setTabelaCaptacaoTotalValues()
		},
		async setDataCaptacaoTopBottomSap() {
			this.dataCaptacaoTopBottomSap = await getTopBottomSap()
		},
		async setDataCaptacaoTopBottomSai() {
			this.dataCaptacaoTopBottomSai = await getTopBottomSai()
		},

		async setRelatorioAgendamento() {
			let params = {}

			if (this.dataRelatorioPoliticaAgendamentoInicial) {
				params.data_inicial = this.dataRelatorioPoliticaAgendamentoInicial
			}
			if (this.dataRelatorioPoliticaAgendamentoFinal) {
				params.data_final = this.dataRelatorioPoliticaAgendamentoFinal
			}
			if (this.filterRelatorioPoliticaAgendamento.tipo_gestao) {
				params.tipo_gestao = this.filterRelatorioPoliticaAgendamento.tipo_gestao
			}

			const responseRelatorioAgendamento =
				await getRelatorioPoliticaAgendamento(params)

			this.dataRelatorioPoliticaAgendamento =
				responseRelatorioAgendamento?.dados_gerais || 0.0
		},

		formatDataPeriodoAgendamento(data) {
			if (!data) return ''

			return data
		},
	},
	mounted() {
		// GLOBAL.formatReal2

		setTimeout(async () => {
			await this.iniciarTabelas()
			this.setSelectUsuarios()
			this.setSelectPoliticas()
			this.setSelectEvents()
			this.setSelectFaixaMesesPatrimonio()
			this.initFilterRelatorioPoliticaAgendamentoDates()
			await this.setDataCaptacaoTopBottomSap()
			await this.setDataCaptacaoTopBottomSai()
			await this.setRelatorioAgendamento()
		}, 300)
	},
	delimiters: ['{*', '*}'],
}
